<template>
  <div class="mx-4">
    <div v-bind:class="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div :class="result">
      <div class="row pb-4">
        <div class="col-12 pb-3 text-center">
          <h4>Ofertas de botón de pánico</h4>
        </div>
        <div class="col-12" style="display: flex; justify-content: space-between">
          <v-btn color="primary" elevation="1" :disabled="newOffer" @click="Nueva_Oferta">Nueva oferta</v-btn>
          <v-btn color="primary" elevation="1" v-show="!newOffer" @click="Consultar">Consultar</v-btn>
        </div>
      </div>
      <div v-show="!newOffer" class="row">
        <div class="col-12 mt-3">
          <v-card>
            <v-card-title style="display: flex; justify-content: flex-end">
              <v-col cols="12">
                <v-row style="display: flex; align-items: flex-end">
                  <v-col cols="4" class="pa-1">
                    <v-dialog ref="dialogBegin" v-model="modalBegin" :return-value.sync="begin" persistent width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="dateRangeText"
                          label="Rango de fechas"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          hide-details
                          class="pr-2 pb-1"
                        ></v-text-field>
                      </template>
                      <v-date-picker :title-date-format="titleDateFormat" v-model="begin" range locale="es">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modalBegin = false"> Cancelar </v-btn>
                        <v-btn text color="primary" @click="$refs.dialogBegin.save(begin)"> OK </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-text-field
                      hide-details
                      v-model="send.MU"
                      label="MU"
                      solo
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-text-field
                      hide-details
                      v-model="send.idfirmarse_sistema"
                      label="Agente"
                      solo
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-autocomplete
                      hide-details
                      v-model="send.nomestatus"
                      :items="filter.nomestatus"
                      label="Estatus"
                      solo
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="8" class="pa-1">
                <v-btn elevation="2" @click="cleanFilter">Limpiar</v-btn>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details></v-text-field>
              </v-col>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              class="elevation-1"
              hide-default-footer
              loading-text="Cargando usuarios... Porfavor espere"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <div class="pa-1">
                  <button
                    v-on:click.prevent="Mostrar_Detalle_Solicitud(item.idtiempoextraoferta)"
                    class="btn teleperformance-purpura2 view-details"
                  >
                    Ver detalle
                  </button>
                </div>
              </template>
              <template v-slot:no-data> No hay información disponible </template>
              <template v-slot:no-results> No se obtuvieron resultados </template>
            </v-data-table>
            <PaginationFooter
              @sendItemsPerPage="getItemsPerPage"
              @lastClic="lastClic"
              @nextClic="nextClic"
              :page="page"
              :itemsLength="itemsLength"
            />
          </v-card>
        </div>
      </div>
      <div v-show="newOffer">
        <hr />
        <div class="row">
          <div class="col-3" style="display: flex; align-items: center">Management Unit</div>
          <div class="col-9">
            <div style="max-width: 250px">
              <v-autocomplete
                hide-details
                v-model="formNew.management_unit"
                :items="mus"
                label="Seleccionar"
                solo
                dense
                no-data-text="No se obtuvieron resultados"
              ></v-autocomplete>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-3" style="display: flex; align-items: center">Fecha</div>
          <div class="col-9">
            <div style="max-width: 250px">
              <v-dialog ref="dialogDate" v-model="modal" :return-value.sync="formNew.fecha_creacion" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    solo
                    v-model="formNew.fecha_creacion"
                    dense
                    label="Fecha de inicio"
                    hide-details
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="formNew.fecha_creacion" scrollable locale="es">
                  <v-spacer></v-spacer>
                  <v-btn text @click="modal = false"> Cancelar </v-btn>
                  <v-btn text color="primary" @click="$refs.dialogDate.save(formNew.fecha_creacion)"> Aceptar </v-btn>
                </v-date-picker>
              </v-dialog>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-3" style="display: flex; align-items: center">Hora Inicio</div>
          <div class="col-9">
            <div style="max-width: 250px">
              <v-dialog ref="dialogTime" v-model="modal3" :return-value.sync="formNew.hora_inicio" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <div style="max-height: 38px">
                    <v-text-field
                      hide-details
                      style="height: 38px !important"
                      solo
                      v-model="formNew.hora_inicio"
                      label="Hora Inicio"
                      prepend-inner-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </div>
                </template>
                <v-time-picker v-if="modal3" v-model="formNew.hora_inicio" full-width>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modal3 = false"> Cancelar </v-btn>
                  <v-btn text color="primary" @click="$refs.dialogTime.save(formNew.hora_inicio)"> Aceptar </v-btn>
                </v-time-picker>
              </v-dialog>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-3" style="display: flex; align-items: center">Hora Final</div>
          <div class="col-9">
            <div style="max-width: 250px">
              <v-dialog ref="dialogTime2" v-model="modal2" :return-value.sync="formNew.hora_final" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    hide-details
                    v-model="formNew.hora_final"
                    label="Hora Final"
                    solo
                    prepend-inner-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker v-if="modal2" v-model="formNew.hora_final" full-width>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modal2 = false"> Cancelar </v-btn>
                  <v-btn text color="primary" @click="$refs.dialogTime2.save(formNew.hora_final)"> Aceptar </v-btn>
                </v-time-picker>
              </v-dialog>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-3" style="display: flex; align-items: center">Slots</div>
          <div class="col-9">
            <div style="max-width: 250px">
              <v-text-field hide-details solo dense label="Slots" v-model="formNew.slots" type="number"></v-text-field>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-3" style="display: flex; align-items: center">Longitud Mínima</div>
          <div class="col-9">
            <div style="max-width: 250px">
              <v-autocomplete
                hide-details
                item-text="item"
                item-value="value"
                v-model="formNew.longitud_minima"
                :items="longitud_minima"
                label="Seleccionar"
                solo
                dense
                no-data-text="No se obtuvieron resultados"
              ></v-autocomplete>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-3" style="display: flex; align-items: center">Tipo de Actividad</div>
          <div class="col-9">
            <div style="max-width: 250px">
              <v-autocomplete
                hide-details
                v-model="formNew.tipo_actividad"
                :items="TiempoExtraEnum"
                label="Seleccionar"
                solo
                dense
                no-data-text="No se obtuvieron resultados"
              ></v-autocomplete>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-3" style="display: flex; align-items: center">Oferta encendida</div>
          <div class="col-9">
            <input type="checkbox" class="checkbox-oferta-encendida" v-model="formNew.oferta_encendida" />
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-3" style="display: flex; align-items: center">Regla 48+ (No será posible modificar en el futuro)</div>
          <div class="col-9">
            <input type="checkbox" class="checkbox-regla-48-horas" v-model="formNew.regla_48" :disabled="Aplica_Regla_48_Horas()" />
          </div>
        </div>
        <hr />
        <div class="text-right">
          <button class="btn btn-sm btn-success" style="width: 80px" @click="Crear_Oferta()">Crear</button>
          <button class="btn btn-sm btn-danger" style="width: 80px" @click="Cancelar_Oferta()">Cancelar</button>
        </div>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";

import { TiempoExtraEnum } from "@/utils/enums/TiempoExtraEnum";
import { VersionIxeEnum } from "@/utils/enums/VersionIxeEnum";
import GeneralMixin from "@/components/mixins/General";

import { mapState, mapActions } from "vuex";
import PaginationFooter from "@/components/General/PaginationFooter";
import axios from "axios"; // Importar Axios en el componente

export default {
  mixins: [GeneralMixin],
  components: {
    PaginationFooter,
  },
  data: function () {
    return {
      url: process.env.VUE_APP_URL,
      time: null,
      modal2: false,
      modal3: false,
      date: "",
      modal: false,
      datatable: null,
      loading: "",
      result: "",
      ofertas: [],
      newOffer: false,
      formNew: {
        management_unit: "",
        fecha_creacion: "",
        hora_inicio: "",
        hora_final: "",
        slots: "",
        longitud_minima: "",
        tipo_actividad: "",
        oferta_encendida: false,
        regla_48: false,
      },
      mus: [],
      longitud_minima: [
        { value: "1800", item: "00:30" },
        { value: "3600", item: "01:00" },
        { value: "5400", item: "01:30" },
        { value: "7200", item: "02:00" },
        { value: "9000", item: "02:30" },
        { value: "10800", item: "03:00" },
        { value: "12600", item: "03:30" },
        { value: "14400", item: "04:00" },
        { value: "16200", item: "04:30" },
        { value: "18000", item: "05:00" },
        { value: "19800", item: "05:30" },
        { value: "21600", item: "06:00" },
        { value: "23400", item: "06:30" },
        { value: "25200", item: "07:00" },
        { value: "27000", item: "07:30" },
        { value: "28800", item: "08:00" },
        { value: "30600", item: "08:30" },
        { value: "32400", item: "09:00" },
        { value: "34200", item: "09:30" },
        { value: "36000", item: "10:00" },
        { value: "39600", item: "10:30" },
        { value: "41400", item: "11:00" },
        { value: "43200", item: "11:30" },
        { value: "45000", item: "12:00" },
      ],
      TiempoExtraEnum: ["Schedule Extension", "Under Time", "Client Schedule Extension"],
      headers: [
        { text: "ID", align: "left", value: "idtiempoextraoferta" },
        { text: "Management Unit", align: "start", value: "mu" },
        { text: "WFM Creador", align: "left", value: "idencargado_sistema" },
        { text: "Fecha de oferta inicio", align: "left", value: "fecha_inicio" },
        { text: "Fecha de oferta fin", align: "left", value: "fecha_fin" },
        { text: "Tipo de actividades", align: "left", value: "idactividad" },
        { text: "Fecha de creación", align: "left", value: "fecha_creacion" },
        { text: "Estado", align: "center", value: "status" },
        { text: "Solicitudes +48 pendientes", align: "center", value: "num_solicitudes" },
        { text: "Acciones", align: "center", value: "actions" },
      ],
      items: [],
      itemsBackup: [],
      filter: {
        nomestatus: ["Activado", "Desactivado"],
      },
      send: {
        MU: "",
        nomagente_sistema_propuesta: "",
        nomestatus: "",
        motivo: "",
      },
      begin: [],
      modalBegin: false,
      search: "",
      maxPages: 1000,
      data: {
        skip: 1,
        take: 10,
        filters: {
          fechas: this.begin,
          statusActivo: 1,
        },
      },
      page: 1,
      itemsPerPage: 10,
      itemsLength: 0,
    };
  },
  mounted() {
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);

    this.begin = [sevenDaysAgo.toISOString().substr(0, 10), new Date().toISOString().substr(0, 10)];
    this.Consultar();
  },
  methods: {
    ...mapActions("horarios", ["setComponent"]),
    getItemsPerPage(dato) {
      this.itemsPerPage = parseInt(dato);
      this.page = 1;
      this.data = {
        skip: this.page,
        take: this.itemsPerPage,
        filters: {
          fechas: this.begin,
          statusActivo: this.send.nomestatus === "Activado" ? 1 : this.send.nomestatus === "Desactivado" ? 0 : undefined,
          mu: this.send.MU ? this.send.MU : undefined,
          agente: this.send.idfirmarse_sistema ? this.send.idfirmarse_sistema : undefined,
        },
      };
      this.Consultar();
    },
    lastClic() {
      this.page--;
      this.data = {
        skip: this.page,
        take: this.itemsPerPage,
        filters: {
          fechas: this.begin,
          statusActivo: this.send.nomestatus === "Activado" ? 1 : this.send.nomestatus === "Desactivado" ? 0 : undefined,
          mu: this.send.MU ? this.send.MU : undefined,
          agente: this.send.idfirmarse_sistema ? this.send.idfirmarse_sistema : undefined,
        },
      };
      this.Consultar();
    },
    nextClic() {
      this.page++;
      this.data = {
        skip: this.page,
        take: this.itemsPerPage,
        filters: {
          fechas: this.begin,
          statusActivo: this.send.nomestatus === "Activado" ? 1 : this.send.nomestatus === "Desactivado" ? 0 : undefined,
          mu: this.send.MU ? this.send.MU : undefined,
          agente: this.send.idfirmarse_sistema ? this.send.idfirmarse_sistema : undefined,
        },
      };
      this.Consultar();
    },
    Obtener_Url(url) {
      return (this.usuario.sistema == VersionIxeEnum.R3 ? "r3/" : "") + url;
    },
    Obtener_Fecha_Fin(fecha_inicio_horario, hora_inicio, hora_fin) {
      const fecha_inicio = moment(fecha_inicio_horario + " " + hora_inicio);
      const fecha_fin = moment(fecha_inicio_horario + " " + hora_fin);
      return fecha_fin.isBefore(fecha_inicio) ? fecha_fin.add(1, "day").clone() : fecha_fin;
    },
    Aplica_Regla_48_Horas() {
      if (this.formNew.tipo_actividad == TiempoExtraEnum.SCHEDULE_EXTENSION) {
        return false;
      } else if (this.formNew.tipo_actividad == TiempoExtraEnum.CLIENT_SCHEDULE_EXTENSION) {
        return false;
      } else {
        this.formNew.regla_48 = false;
        return true;
      }
    },
    async Consultar() {
      this.Cargando();
      this.Obtener_MUS();
      try {
        // A futuro cambiara la estructura del proyecto y esto quedara en el router estos dos headers
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("apiKey_tp");
        axios.defaults.headers.common["accesstoken"] = localStorage.getItem("tokenmsal");
        if (this.begin.length < 2) {
          this.begin[1] = this.begin[0];
        }
        const url = this.url + "v2/api/admin/filter/boton/panico";
        let data = (this.data = {
          skip: this.page,
          take: this.itemsPerPage,
          filters: {
            fechas: this.begin,
            statusActivo: this.send.nomestatus === "Activado" ? 1 : this.send.nomestatus === "Desactivado" ? 0 : undefined,
            mu: this.send.MU ? this.send.MU : undefined,
            agente: this.send.idfirmarse_sistema ? this.send.idfirmarse_sistema : undefined,
          },
        });
        const {
          data: { data: items, count },
        } = await axios.post(url, { data });
        this.items = items.map((obj) => {
          return {
            ...obj,
            fecha_inicio: moment(obj.fecha_inicio).utc().format("DD-MM-YYYY HH:mm"),
            fecha_fin: moment(obj.fecha_fin).utc().format("DD-MM-YYYY HH:mm"),
            fecha_creacion: moment(obj.fecha_creacion).utc().format("DD-MM-YYYY HH:mm"),
            status: obj.esta_activa === 1 ? "Activado" : "Desactivado",
          };
        });
        this.itemsLength = count;
        this.itemsBackup = this.items;

        if (items != null) {
          this.ofertas = items;
        }
        if (this.ofertas.length === 0) {
          swal("No hay ofertas", "Por el momento no hay solicitudes", "info");
        }
        this.loading = "d-none";
        this.result = "";
      } catch (error) {
        if (error.body?.code === "MSAL_TOKEN_IS_NOT_VALID") {
          this.$msal.signOut();
        }
        if (error.response.data.code === "INVALID_TOKEN") {
          // Redirigir al usuario a la página de inicio de sesión
          this.$msal.signOut();
          this.$router.push({ name: "Login" });
        }
        if (error.status !== 401) {
          swal("Problemas para conectarse", "Favor de revisar su conexión a internet", "error");
        }
      }
    },
    Mostrar_Detalle_Solicitud(item) {
      this.setComponent({ component: "detail", item: item });
    },
    Mostrar_Result() {
      this.loading = "d-none";
      this.result = "";
    },
    Cargando() {
      this.loading = "";
      this.result = "d-none";
    },
    Obtener_MUS() {
      const url = this.Obtener_Url("encargados/mus");
      this.$http
        .get(url, {
          headers: this.get_request_headers({
            accesstoken: localStorage.getItem("tokenmsal"),
          }),
        })
        .then((response) => response.json())
        .then((results) => {
          this.mus = results.map((mu) => ({
            text: mu,
            value: mu,
          }));
        });
    },
    Nueva_Oferta() {
      this.newOffer = true;
    },
    Crear_Oferta() {
      if (this.formNew.management_unit == "") {
        toastr.clear();
        toastr.error("El campo Managament Unit se encuentra vacío");
      } else if (!moment(this.formNew.fecha_creacion, "YYYY-MM-DD").isValid()) {
        toastr.clear();
        toastr.error("El campo Fecha es inválido");
      } else if (!moment(this.formNew.hora_inicio, "HH:mm").isValid()) {
        toastr.clear();
        toastr.error("El campo Hora Inicio es inválido");
      } else if (!moment(this.formNew.hora_final, "HH:mm").isValid()) {
        toastr.clear();
        toastr.error("El campo Hora Final es inválido");
      } else if (isNaN(this.formNew.slots) || this.formNew.slots < 1 || this.formNew.slots > 99) {
        toastr.clear();
        toastr.error("El campo Slots es inválido");
      } else if (this.formNew.longitud_minima == "") {
        toastr.clear();
        toastr.error("El campo Longitud Mínima se encuentra vacío");
      } else {
        const fecha_inicio = moment(this.formNew.fecha_creacion + " " + this.formNew.hora_inicio);
        const fecha_fin = this.Obtener_Fecha_Fin(this.formNew.fecha_creacion, this.formNew.hora_inicio, this.formNew.hora_final);

        var data = {
          mu: this.formNew.management_unit,
          fecha_inicio: fecha_inicio.format("YYYY-MM-DD HH:mm"),
          fecha_fin: fecha_fin.format("YYYY-MM-DD HH:mm"),
          slots: parseInt(this.formNew.slots),
          longitud_minima: parseInt(this.formNew.longitud_minima),
          idactividad: this.formNew.tipo_actividad,
          esta_activa: this.formNew.oferta_encendida,
          aplica_48_horas: this.formNew.regla_48,
        };

        const url = this.Obtener_Url("tiempoExtra/ofertas");
        this.$http
          .post(url, data, {
            headers: this.get_request_headers({
              accesstoken: localStorage.getItem("tokenmsal"),
            }),
          })
          .then((response) => response.json())
          .then((results) => {
            this.Consultar();
            this.Cancelar_Oferta();
            toastr.clear();
            toastr.success("Oferta creada exitosamente");
          })
          .catch((e) => {
            if (e.body.code == "MSAL_TOKEN_IS_NOT_VALID") {
              this.$msal.signOut();
            }
            toastr.error(e.body.mensaje);
          });
      }
    },
    Cancelar_Oferta() {
      this.formNew = {
        management_unit: "",
        fecha_creacion: "",
        hora_inicio: "",
        hora_final: "",
        slots: "",
        longitud_minima: "",
        tipo_actividad: "",
        oferta_encendida: false,
        regla_48: false,
      };
      this.newOffer = false;
    },
    cleanFilter() {
      for (let key in this.send) {
        this.send[key] = "";
      }
      this.Consultar();
    },
  },
  computed: {
    ...mapState({
      usuario: (state) => state.menu.menu.usuario,
    }),
    dateRangeText() {
      return this.begin.join(" ~ ");
    },
    titleDateFormat() {
      // Aquí puedes incluir la clase personalizada en la cadena de formato de fecha
      return (date) => {
        return this.$vuetify.lang.t("Fechas seleccionadas");
      };
    },
  },
};
</script>
<style>
.checkbox-oferta-encendida {
  transform: scale(1.5);
}

.checkbox-regla-48-horas {
  transform: scale(1.5);
}
.v-text-field.v-text-field--solo .v-input__control {
  min-height: 38px;
}
</style>
